import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Siderbar from "./Siderbar";
import Overall from "./Overall";
import RoundInfo from "./Round/roundInfo/roundInfoPage";
import Members from "./members/members";
import EditMember from "./members/editmember";
import AddMember from "./members/addmember";
import EditRound from "./Round/roundInfo/editround";
import CreateRound from "./Round/roundInfo/createround";
import AddMemberRound from "./Round/roundInfo/addMember";
import CreateMemberRound from "./Round/roundInfo/creatememberround";
import Contribution from "./Round/contribution/contribution";
import Capital from "./Round/contribution/capital";
import Distribution from "./Round/distribution/distributionInfo";
import CreatePayment from "./payments/createpayments";
import RecordPayment from "./payments/recordpayments";
import RecordExpenses from "./payments/recordexpenses";
import PaymentApproval from "./payments/paymentapproval";
import Spendings from "./payments/spending";
import Convert from "./payments/convert";
import UploadPayments from "./payments/uploadpayments";
import Allloans from "./loan/allloans";
import LoanRequest from "./loan/requestloan";
import LoanAproval from "./loan/LoanApprove";
import LoanEdit from "./loan/editloan";
import LoanCheck from "./loan/checkApproval";
import IncomeReport from "./reports/incomeReport";
import ExpenseReport from "./reports/expenseReport";
import Cashbook from "./reports/cashbookReport";
import Financialstatements from "./reports/statementReport";
import OtherReport from "./reports/otherreports";
import Commissions from "./Round/contribution/commission";
import Penalties from "./Round/contribution/penalities";
import Usergroups from "./SystemSettings/Usergroups";
import Myapproval from "./Requests/Myapproval";
import RoundSchedules from "./Round/distribution/roundschedules";
import Memberdetails from "./members/memberdetails";
import LoanDetails from "./loan/laondetails";
import AdminSettings from "./SystemSettings/adminsettings";
import Filem from "./file/filemanager";
import Auth from "../Auth";
import Assets from "./assets/assets";
import AddAsset from "./assets/addAsset";
import EditAsset from "./assets/editAsset";
import Profile from "./SystemSettings/profile";
import MyMembership from "./members/MyMembership";
import { canAccessRoute, defaultMainPath, routePage } from "../security/routes";
import WorkspacePage from "./WorkspacePage";
import PaymentTabs, { isPaymentRoute } from "./payments/PaymentTabs";

export const legacyPageTitles = {
  Overall: "Overview", RoundInfo: "Round Information", Profile: "Admin Settings",
  Members: "Users", AddMember: "Add User", EditMember: "Edit User",
  EditRound: "Edit Round", CreateRound: "Create Round", AddMemberRound: "Add Round Member",
  CreateMemberRound: "Create Round Member", Contribution: "Contributions", Capital: "Capital Contributions",
  Distribution: "Distributions", RecordPayment: "Payments", RecordExpenses: "Record Expenses",
  PaymentApproval: "Payment Approval", Spendings: "Spendings", CreatePayment: "Create Payment",
  Convert: "Convert Payment", Allloans: "Loans", LoanRequest: "Request Loan", LoanAproval: "Loan Approval",
  LoanCheck: "Loan Approval Check", LoanEdit: "Edit Loan", LoanDetails: "Loan Details",
  IncomeReport: "Income Report", ExpenseReport: "Expense Report", Cashbook: "Cashbook",
  otherreports: "Other Reports", Financialstatements: "Financial Statements", file: "File Manager",
  Commissions: "Commissions", Penalties: "Penalties", Adminsettings: "Round Settings",
  Myapproval: "Requests", Memberdetails: "Member Details", Roundschedules: "Distribution Schedules",
  Assets: "Assets", AddAsset: "Add Asset", EditAsset: "Edit Asset",
};

export function ProtectedRoute({ component: Page, ...rest }) {
  return <Route {...rest} render={(props) => {
    if (!canAccessRoute(props.location.pathname)) return <Redirect to={defaultMainPath()} />;
    const title = legacyPageTitles[routePage(props.location.pathname)];
    const paymentPage = isPaymentRoute(props.location.pathname);
    return title ? <WorkspacePage title={title} legacy className={paymentPage ? "payments-workspace" : ""}>
      {paymentPage && <PaymentTabs />}<Page {...props} />
    </WorkspacePage> : <Page {...props} />;
  }} />;
}

// import packageJson from "../../package.json";
// import Reset from "./Reset";

export class Main extends Component {
  render() {
    //alert("Calling main");
    Auth.caching();
    Auth.timecheck(false);
    return (
      <div className="page-content workspace-layout">
        <Siderbar />

        <Switch>
          <Route exact path="/Main" render={() => <Redirect to={defaultMainPath()} />} />
          <Route path="/Main/MyMembership" component={MyMembership} />
          <ProtectedRoute path="/Main/Overall" component={Overall} />
          <ProtectedRoute path="/Main/RoundInfo" component={RoundInfo} />
          <ProtectedRoute path="/Main/Profile" component={Profile} />
          <ProtectedRoute path="/Main/Members" component={Members} />
          <ProtectedRoute path="/Main/AddMember" component={AddMember} />
          <ProtectedRoute path="/Main/EditMember" component={EditMember} />
          <ProtectedRoute path="/Main/EditRound" component={EditRound} />
          <ProtectedRoute path="/Main/CreateRound" component={CreateRound} />
          <ProtectedRoute path="/Main/AddMemberRound" component={AddMemberRound} />
          <ProtectedRoute path="/Main/CreateMemberRound" component={CreateMemberRound} />
          <ProtectedRoute path="/Main/Contribution" component={Contribution} />
          <ProtectedRoute path="/Main/Capital" component={Capital} />
          <ProtectedRoute path="/Main/Distribution" component={Distribution} />
          <ProtectedRoute path="/Main/RecordPayment" component={RecordPayment} />
          <ProtectedRoute path="/Main/RecordExpenses" component={RecordExpenses} />
          <ProtectedRoute path="/Main/PaymentApproval" component={PaymentApproval} />
          <ProtectedRoute path="/Main/Spendings" component={Spendings} />
          <ProtectedRoute path="/Main/CreatePayment" component={CreatePayment} />
          <ProtectedRoute path="/Main/UploadPayments" component={UploadPayments} />
          <ProtectedRoute path="/Main/Convert" component={Convert} />
          <ProtectedRoute path="/Main/Allloans" component={Allloans} />
          <ProtectedRoute path="/Main/LoanRequest" component={LoanRequest} />
          <ProtectedRoute path="/Main/LoanAproval" component={LoanAproval} />
          <ProtectedRoute path="/Main/LoanCheck" component={LoanCheck} />
          <ProtectedRoute path="/Main/LoanEdit" component={LoanEdit} />
          <ProtectedRoute path="/Main/IncomeReport" component={IncomeReport} />
          <ProtectedRoute path="/Main/ExpenseReport" component={ExpenseReport} />
          <ProtectedRoute path="/Main/Cashbook" component={Cashbook} />
          <ProtectedRoute path="/Main/otherreports" component={OtherReport} />
          <ProtectedRoute path="/Main/file" component={Filem} />
          <ProtectedRoute
            path="/Main/Financialstatements"
            component={Financialstatements}
          />
          <ProtectedRoute path="/Main/Commissions" component={Commissions} />
          <ProtectedRoute path="/Main/Penalties" component={Penalties} />
          <ProtectedRoute path="/Main/Usergroups" component={Usergroups} />
          <ProtectedRoute path="/Main/Adminsettings" component={AdminSettings} />
          <ProtectedRoute path="/Main/Myapproval" component={Myapproval} />
          <ProtectedRoute path="/Main/Memberdetails" component={Memberdetails} />
          <ProtectedRoute path="/Main/LoanDetails" component={LoanDetails} />
          <ProtectedRoute path="/Main/Roundschedules" component={RoundSchedules} />
          <ProtectedRoute path="/Main/Assets" component={Assets} />
          <ProtectedRoute path="/Main/AddAsset" component={AddAsset} />
          <ProtectedRoute path="/Main/EditAsset" component={EditAsset} />
          <Route render={() => <Redirect to={defaultMainPath()} />} />
          {/* <Route path="/Main/Reset" component={Reset} /> */}
        </Switch>
      </div>
    );
  }
}

export default Main;
